import React, { PureComponent } from 'react'
import {
  Paper,
  Table,
  TableCell,
  TableRow,
  Grid,
  TableBody,
  TableHead,
  TableSortLabel,
} from '@material-ui/core'

import { CreateDriverForm, DriverTableRow } from './components'

export class DriversBase extends PureComponent {
  createSortHandler = property => e => this.props.requestSortHandler(e, property)

  renderDriver = ({ id, label, company }) => {
    const { classes, setDriver, deleteDriver } = this.props
    
    return (
      <DriverTableRow
        id={id}
        key={id}
        label={label}
        company={company}
        classes={classes}
        setDriver={setDriver}
        deleteDriver={deleteDriver}
      />
    )
  }

  getSorting(order, orderBy) {
    return order === 'desc'
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  }

  render() {
    const { drivers, order, orderBy, classes } = this.props

    return (
      <Grid
        container
        spacing={8}
        component={Paper}
        direction='column'
      >
        <Grid item>
          <CreateDriverForm />
        </Grid>

        <Grid item xs>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell} padding='dense'>
                  <TableSortLabel
                    active={orderBy === 'label'}
                    onClick={this.createSortHandler('label')}
                    direction={order.length > 0 ? order : 'asc'}
                  >
                    ПІБ
                  </TableSortLabel>
                </TableCell>

                <TableCell padding='checkbox' />
              </TableRow>
            </TableHead>

            <TableBody>
              {drivers.sort(this.getSorting(order, orderBy)).map(this.renderDriver)}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Drivers/Drivers.js